module.exports = __webpack_public_path__ + "static/img/infoCover2.64297b8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/infoCover2.jpg
// module id = 91
// module chunks = 1 4